// extracted by mini-css-extract-plugin
module.exports = {"bb-featured-news":"bb-featured-news__qijqy"};